import React from 'react'
import { SvgComponent } from './type'

export const Check: SvgComponent = (props) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.8382 1.93244L5.81716 13.9524L0.160156 8.29744L1.57016 6.88744L5.81716 11.1234L16.4272 0.523438L17.8372 1.93344L17.8382 1.93244Z"
      fill="#4E6280"
    />
  </svg>
)
